<script setup lang="ts">
import type { WaitlistNotification } from "@/schemas/waitlist";

const { waitlist, isLoading, status, error } = useWaitlist();
const columns: TableColumn<WaitlistNotification>[] = [
  {
    key: "product",
    label: "Produit",
  },
  {
    key: "stock_status",
    label: "État de stock",
    verticalAlign: "middle",
  },
  {
    key: "timestamp",
    label: "Date d'ajout",
    width: "128px",
    mobileFullWidth: true,
    verticalAlign: "middle",
  },
  {
    key: "actions",
    label: "",
    horizontalAlign: "right",
    verticalAlign: "middle",
  },
];
</script>

<template>
  <UiDefaultPage id="my-waitlist" title="Liste d'attente">
    <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
      <UiEmptyResult v-if="!waitlist.notifications.length" title="Aucun produit dans la liste d'attente" />
      <UiResponsiveTable v-else :columns="columns" :data="waitlist.notifications">
        <template #product-cell="{ row }">
          <ProductListItem :product="row.product" />
        </template>
        <template #stock_status-cell="{ row }">
          {{ row.product.in_stock ? "En stock" : "Rupture de stock" }}
        </template>
        <template #timestamp-cell="{ row }">
          {{ date(row.timestamp) }}
        </template>
        <template #actions-cell="{ row }">
          <ProductRemoveFromWaitlist :notification-id="row.notification_id" />
        </template>
      </UiResponsiveTable>
    </UiQueryWrapper>
  </UiDefaultPage>
</template>
